import React from 'react';
import ReactDOM from 'react-dom/client'
import { ProfileComponent, ProfileComponentProps } from './ProfileComponent';


function renderProfileComponent(props: ProfileComponentProps) {
    ReactDOM.createRoot(document.getElementById('profileWrapper') as HTMLElement).render(
        <ProfileComponent 
            organizationName={props.organizationName} 
            user={props.user} 
            customContent={props.customContent}
            env={props.env} 
            locale={props.locale}
            onSignOut={props.onSignOut}
            hideLaguage={props.hideLaguage}
            profileCircleSize={props.profileCircleSize}
            profileTextSize={props.profileTextSize}
             />
    )
}

// @ts-ignore
window.renderProfileComponent = renderProfileComponent;

export {
    renderProfileComponent
}